<div class="conteneur-camille-header-cnaf" [ngSwitch]="etat">
    <div *ngSwitchCase="'reponses'">
        <div class="row">
            <div class="col-xs-12">
                <div class="conteneur-question-camille-cnaf
                    conteneur-question-camille-cnaf-print
                    conteneur-question-margin">
                    <span class="texte-bold">
                        {{formuel ? 'L\'objet de votre recherche :' : 'Rappel de votre question :'}}
                    </span>
                    <span>{{question}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="mise-en-avant-fond-cnaf">
        <div class="row">
            <div *ngSwitchCase="'error'">
                <div class="visible-xs">
                    <div class="col-xs-2 vcenter">
                        <img class="img-responsive img-circle avatar-camille"
                        src="/icfstatiquesangularappli/dist/images/avatar-camille.png"
                        alt="Camille"/>
                    </div>
                    <div class="col-xs-10 vcenter">
                        <p class="label-form-cnaf text-avatar-camille" style="margin-right: 10px;">
                            Je suis désolée mais je suis momentanément indisponible.
                        </p>
                    </div>
                    <div class="col-xs-12">
                        <p class="label-form-cnaf text-avatar-camille margin-p-camille bigger-font-weight"> 
                            Je vous propose de réessayer plus tard ou de transmettre directement votre mail à votre Caf.
                        </p>
                    </div>
                </div>
                <div class="hidden-xs col-sm-12">
                    <img class="img-responsive img-circle avatar-camille"
                    src="/icfstatiquesangularappli/dist/images/avatar-camille.png"
                    alt="Camille"/>
                    <p class="text-left label-form-cnaf text-avatar-camille bigger-font-weight">
                        Je suis désolée mais je suis momentanément indisponible.<br/>
                        Je vous propose de réessayer plus tard ou de transmettre directement votre mail à votre Caf.
                    </p>
                </div>
            </div>
            <div *ngSwitchCase="'resultatsVide'">
                <div class="visible-xs">
                    <div class="col-xs-2 vcenter">
                        <img class="img-responsive img-circle avatar-camille"
                        src="/icfstatiquesangularappli/dist/images/avatar-camille.png"
                        alt="Camille"/>
                    </div>
                    <div class="col-xs-10 vcenter">
                        <p class="label-form-cnaf text-avatar-camille" style="margin-right: 3px;">
                            Je vous remercie pour votre question :<br/>
                            Je ne peux pas y répondre.
                        </p>
                    </div>
                </div>
                <div class="hidden-xs col-sm-12">
                    <img class="img-responsive img-circle avatar-camille"
                    src="/icfstatiquesangularappli/dist/images/avatar-camille.png"
                    alt="Camille"/>
                    <p class="text-left label-form-cnaf text-avatar-camille">
                        Je vous remercie pour votre question :<br/>
                        Je ne peux pas y répondre.
                    </p>
                </div>
            </div>
            <div *ngSwitchCase="'reponses'">
                <div class="visible-xs">
                    <div class="col-xs-2 vcenter">
                        <img class="img-responsive img-circle avatar-camille"
                        src="/icfstatiquesangularappli/dist/images/avatar-camille.png"
                        alt="Camille"/>
                    </div>
                    <div class="col-xs-10 vcenter">
                        <p class="label-form-cnaf text-avatar-camille bigger-font-weight" style="margin-right: 3px;">
                            <span [hidden]="formuel">
                                Je vous remercie pour votre question.<br/>
                            </span>
                            Je vous propose les réponses suivantes :
                        </p>
                    </div>
                </div>
                <div class="hidden-xs col-sm-12">
                    <img class="img-responsive img-circle avatar-camille"
                    src="/icfstatiquesangularappli/dist/images/avatar-camille.png"
                    alt="Camille"/>
                    <p class="text-left label-form-cnaf text-avatar-camille bigger-font-weight">
                        <span [hidden]="formuel">
                            Je vous remercie pour votre question.<br/>
                        </span>
                        Je vous propose les réponses suivantes :
                    </p>
                </div>
            </div>
            <div *ngSwitchDefault>
                <div class="visible-xs">
                    <div class="col-xs-2 vcenter">
                        <img class="img-responsive img-circle avatar-camille"
                        src="/icfstatiquesangularappli/dist/images/avatar-camille.png"
                        alt="Camille"/>
                    </div>
                    <div class="col-xs-10 vcenter">
                        <p class="label-form-cnaf text-avatar-camille bigger-font-weight" style="margin-right: 10px;">
                            Bonjour, je suis Camille, votre assistante virtuelle. Je vais tenter de répondre à votre question.
                        </p>
                    </div>
                    <div class="col-xs-12">
                        <p class="label-form-cnaf text-avatar-camille margin-p-camille">
                            Si mes réponses ne vous conviennent pas, à l'étape suivante vous pourrez écrire votre mail et l'envoyer à votre Caf.
                        </p>
                    </div>
                </div>
                <div class="hidden-xs col-sm-12">
                    <img class="img-responsive img-circle avatar-camille"
                    src="/icfstatiquesangularappli/dist/images/avatar-camille.png"
                    alt="Camille"/>
                    <p class="label-form-cnaf text-avatar-camille bigger-font-weight">
                        Bonjour, je suis Camille, votre assistante virtuelle. Je vais tenter de répondre à votre question.<br/>
                        Si mes réponses ne vous conviennent pas, à l'étape suivante vous pourrez écrire votre mail et l'envoyer à votre Caf.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
